// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"d4720840","692":"2d8ffd0a","767":"e823892d"}[chunkId] + ".chunk.css";
};